export default __webpack_public_path__ + "static/media/online.70e4c870.svg";